import Class from './c-content-text-bars';
import './c-content-text-bars@.vue';

export default Class;